// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"d19c4956e0fa3a55e30e","655":"86254dce0dce9443a535"}[chunkId] + ".js";
};